<template>

  <div class="login-buttons">
    <!-- / -->
    <b-button v-if="!propsIsMemberLogin"
              v-bind:href="propsRootUrl+'/member_login/'"
              id="btnLogin"
              class="btn btn-primary">
      <img class="iconLogin d-md-none" v-bind:src="propsThemeDir+'/module/img/common/icon_login-sp.png'" alt="ログイン">
      <img class="iconLogin d-none d-md-inline" v-bind:src="propsThemeDir+'/module/img/common/icon_login-pc.png'" alt="ログイン">
      <span class="d-block d-md-inline">
        <span class="d-none d-md-inline">
          会員
        </span>
        ログイン
      </span>
    </b-button>
    <!-- / -->
    <b-button v-if="propsIsMemberLogin"
              v-bind:href="propsRootUrl+'/member_login/?action=logout'"
              id="btnLogout"
              class="btn btn-primary">
      <img class="iconLogout d-md-none" v-bind:src="propsThemeDir+'/module/img/common/icon_logout-sp.png'" alt="ログアウト">
      <img class="iconLogout d-none d-md-inline" v-bind:src="propsThemeDir+'/module/img/common/icon_logout-pc.png'" alt="ログアウト">
      <span class="d-block d-md-inline">ログアウト</span>
    </b-button>
    <!-- / -->
  </div>

</template>

<script>
    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        props:{
          propsIsMemberLogin: {
            type: Boolean,
            default: false
          },
          propsRootUrl: {
            type:String
          },
          propsThemeDir: {
            type:String
          }
        },
        mounted() {
            console.log('HeaderLoginButtonsComponent mounted.')
        }
    }
</script>
